import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import {
  GridComponent,
  Inject,
  ColumnDirective,
  ColumnsDirective,
  CommandColumn,
  Page,
  Filter,
  Toolbar,
  ExcelExport,
  Sort,
  Resize,
  Group,
  Freeze,
} from "@syncfusion/ej2-react-grids";
import { useVendorMasterStore } from "../../../store/useVendorMasterStore";
import ApprovedStatusModal from "../ApprovedStatusModal.js";
import { generateVendorPDF } from "../NewRegisterVendorMaster/Pdf/generateVendorPdf.js";
import {
  getVendorDetailByGUIDApi,
  syncVendorReportApi,
} from "../../../services/vendorMaster.js";
import { message, Modal } from "antd";

const VendorReportGrid = ({ lastPayload }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const {
    vendorReports,
    getVendorReports,
    loading,
    setLoading,
    getVendorStatusReport,
  } = useVendorMasterStore();
  const [modalOpen, setModalOpen] = useState(false);
  const [guid, setGuid] = useState(null);
  const [syncLoading, setSyncLoading] = useState(false);
  const [syncModalOpen, setSyncModalOpen] = useState(false);
  const [selectedVendorGUID, setSelectedVendorGUID] = useState(null);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  let gridInstance;
  const toolbarClick = (args) => {
    if (gridInstance && args.item.id === "BrokerGrid_excelexport") {
      gridInstance.excelExport();
    }
  };
  const handleSyncVendor = async () => {
    if (!selectedVendorGUID) return;

    try {
      setSyncLoading(true);
      await syncVendorReportApi(selectedVendorGUID);
      if (lastPayload) {
        await getVendorReports(lastPayload?.fromDate,lastPayload?.toDate);
      }
      message.success("Vendor synced to SAP successfully");
      setSyncModalOpen(false); // close modal on success
    } catch (err) {
      message.error("SAP Sync failed");
    } finally {
      setSyncLoading(false);
    }
  };

  const openSyncModal = (vendorGUID) => {
    setSelectedVendorGUID(vendorGUID);
    setSyncModalOpen(true);
  };

  const vendorReportsWithFlag = vendorReports.map((row) => ({
    ...row,
    CanDownloadPdf: row.SubmitStatus === "Submitted", // example condition
    CanSync: row.ApprovedStatus === "Approved" && row.SAPStatus === "Not Sync",
    CreatedOn: row.CreatedOn ? new Date(row.CreatedOn) : null,
    SubmittedOn: row.SubmittedOn ? new Date(row.SubmittedOn) : null,
    ApprovedOn: row.ApprovedOn ? new Date(row.ApprovedOn) : null,
  }));

  return (
    <>
      <div
        className={`grid_compact ${isMobile ? "e-bigger" : ""}`}
        style={{
          position: "relative",
          marginTop: "10px",
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          padding: "6px",
          marginBottom: "20px",
        }}
      >
        <Row>
          <Col>
            {loading ? (
              <div style={{ textAlign: "center", padding: "40px 0" }}>
                Loading vendors...
              </div>
            ) : (
              <GridComponent
                ref={(g) => (gridInstance = g)}
                id="BrokerGrid"
                dataSource={vendorReportsWithFlag}
                allowPaging={true}
                allowSorting={true}
                allowFiltering={true}
                allowResizing={true}
                dataBound={() => {
                  if (!isMobile && gridInstance) {
                    gridInstance.autoFitColumns();
                  }
                }}
                filterSettings={{ type: "Excel" }}
                toolbar={["ExcelExport", "Search"]}
                allowExcelExport={true}
                toolbarClick={toolbarClick}
                enableAdaptiveUI={isMobile}
                rowRenderingMode={isMobile ? "Vertical" : "Horizontal"}
                gridLines="Both"
                height={"300px"}
                queryCellInfo={(args) => {
                  if (args.column.headerText === "Actions") {
                    const pdfBtn = args.cell.querySelector(".e-export-pdf");
                    const syncBtn = args.cell.querySelector(".e-sync-btn");
                    if (pdfBtn && !args.data.CanDownloadPdf) {
                      pdfBtn.style.display = "none"; // hide per row
                    }
                    if (syncBtn && !args.data.CanSync) {
                      syncBtn.style.display = "none";
                    }
                  }
                }}
                pageSettings={{
                  pageSizes: [10, 20, 30, 40, 50, "All"],
                  pageCount: 10,
                }}
                rowHeight={isMobile ? "" : 32}
                // frozenColumns={1}
                // rowDataBound={()}
                commandClick={async (args) => {
                  const row = args?.rowData;
                  const icon = args?.commandColumn?.buttonOption?.iconCss;
                  if (!row?.VendorGUID) return;
                  // 👁 VIEW STATUS
                  if (icon?.includes("e-eye")) {
                    await getVendorStatusReport(row.VendorGUID);
                    setGuid(row.VendorGUID);
                    setModalOpen(true);
                    return;
                  }
                  // DOWNLOAD PDF
                  if (icon?.includes("e-export-pdf")) {
                    try {
                      // call API → get full vendor data
                      // setLoading(true);
                      const response = await getVendorDetailByGUIDApi(
                        row.VendorGUID,
                      );
                      // generate PDF
                      generateVendorPDF(response);
                    } catch (err) {
                      console.error(err);
                    } finally {
                      // setLoading(false);
                    }
                  }
                  // SYNC TO SAP
                  if (icon?.includes("e-refresh")) {
                    openSyncModal(row.VendorGUID);
                  }
                }}
              >
                <ColumnsDirective>
                  <ColumnDirective
                    field="serialNo"
                    headerText="S No"
                    width="100"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="VendorGUID"
                    headerText="GUID"
                    width="150"
                    textAlign="Left"
                    // template={linkTemplate}
                  />
                  <ColumnDirective
                    field="DivisionName"
                    headerText="Division Name"
                    width="150"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="DepartmentName"
                    headerText="Department Name"
                    width="150"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="VendorName"
                    headerText="Vendor Name"
                    width="300"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="EmailID"
                    headerText="Email"
                    width="190"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="CreatedBy"
                    headerText="Created By"
                    width="180"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="CreatedOn"
                    headerText="Created On"
                    width="180"
                    textAlign="Left"
                    type="date"
                    format="dd/MM/yyyy"
                  />
                  <ColumnDirective
                    field="SubmitStatus"
                    headerText="Submit Status"
                    width="180"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="ActionTakenByVendor"
                    headerText="Action Taken By Vendor"
                    width="200"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="SubmittedBy"
                    headerText="Submitted By"
                    width="180"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="SubmittedOn"
                    headerText="Submitted On"
                    width="180"
                    textAlign="Left"
                    type="date"
                    format="dd/MM/yyyy"
                  />
                  <ColumnDirective
                    field="ApprovedStatus"
                    headerText="Approved Status"
                    width="180"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="ApprovedOn"
                    headerText="Approved On"
                    width="180"
                    textAlign="Left"
                    type="date"
                    format="dd/MM/yyyy"
                  />
                  <ColumnDirective
                    field="PendingWith"
                    headerText="Pending With"
                    width="180"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="LastActionBy"
                    headerText="Last Action By"
                    width="180"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="LastRemrks"
                    headerText="Last Remrks"
                    width="180"
                    textAlign="Left"
                  />

                  <ColumnDirective
                    field="SAPStatus"
                    headerText="SAP Status"
                    width="150"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="VendorNo"
                    headerText="Vendor No"
                    width="150"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="SAPMessage"
                    headerText="SAP Message"
                    width="150"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    field="SAPSyncOn"
                    headerText="SAP Sync On"
                    width="150"
                    textAlign="Left"
                  />
                  <ColumnDirective
                    headerText="Actions"
                    width="120"
                    textAlign="Center"
                    freeze="Right"
                    commands={[
                      {
                        type: "None",
                        buttonOption: {
                          iconCss: "e-icons e-eye",
                          cssClass: "e-flat e-primary",
                          // title: "View Status",
                          content: "",
                        },
                        tooltipText: "View Status",
                      },
                      {
                        type: "None",
                        buttonOption: {
                          iconCss: "e-icons e-export-pdf",
                          cssClass: "e-flat e-danger",
                          // title: "Download PDF",
                          content: "",
                        },
                        tooltipText: "Download PDF",
                      },
                      {
                        type: "None",
                        buttonOption: {
                          iconCss: "e-icons e-refresh",
                          cssClass: "e-flat e-success e-sync-btn",
                          // title: "Sync to SAP",
                          content: "",
                        },
                        tooltipText: "Sync to SAP",
                      },
                    ]}
                    showInAdaptiveUI={false}
                  />
                </ColumnsDirective>

                <Inject
                  services={[
                    CommandColumn,
                    Page,
                    Filter,
                    Toolbar,
                    ExcelExport,
                    Sort,
                    Group,
                    Resize,
                    Freeze,
                  ]}
                />
              </GridComponent>
            )}
          </Col>
        </Row>
      </div>
      <ApprovedStatusModal
        modalOpen={modalOpen}
        toggleModal={toggleModal}
        guid={guid}
      />
      <Modal
        open={syncModalOpen}
        title="Confirm Sync"
        onOk={handleSyncVendor}
        onCancel={() => setSyncModalOpen(false)}
        okText="Yes, Sync"
        cancelText="Cancel"
        confirmLoading={syncLoading}
        destroyOnClose
      >
        <p>Are you sure you want to sync this vendor to SAP?</p>
      </Modal>
    </>
  );
};

export default VendorReportGrid;
